export interface MemberResponsibleGamingEndProps {
  endDateLabel: string;
  endDateTimeValue: string;
}
export const MemberResponsibleGamingEnd = ({
  endDateLabel,
  endDateTimeValue
}: MemberResponsibleGamingEndProps) => {
  return (
    <div className="bg-soFresh-120 rounded-lg px-4 py-2">
      <p className="text-soClean-180">{endDateLabel} Limits End Date</p>
      <p
        className="text-soClean-100 font-semibold"
        data-testid={`${endDateLabel}-limit-end-date`}
      >
        {endDateTimeValue}
      </p>
    </div>
  );
};
